__webpack_require__.p = "/curam-kubernetes/";